import { render, staticRenderFns } from "./StockJournalRoleEdit.vue?vue&type=template&id=26d95956"
import script from "./StockJournalRoleEdit.vue?vue&type=script&lang=js"
export * from "./StockJournalRoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports